import { useEffect, useRef } from "react";

/**
 * Calls `callback` when the user presses Escape.
 * Only active when `enabled` is true (default).
 * Uses a ref so the listener is registered once and always calls the latest callback.
 */
export default function useOnEscape(callback, enabled = true) {
  const ref = useRef(callback);
  useEffect(() => { ref.current = callback; });

  useEffect(() => {
    if (!enabled) return;
    const handle = (e) => {
      if (e.key === "Escape") ref.current();
    };
    window.addEventListener("keydown", handle);
    return () => window.removeEventListener("keydown", handle);
  }, [enabled]);
}
